import classes from "./Contacts.module.scss";

export default function ContactsPage() {
  return (
    <div className={classes.container}>
      <h1>Contacts</h1>
      <p>
        For any issues with the online booking system, please contact{" "}
        <a href="tel:+994 10 252 44 80">+994 10 252 44 80</a> or send an email
        to <a href="mailto:mds@cop29.az">mds@cop29.az</a>
      </p>

      <div className={classes.mapWrapper}>
        <div className={classes.address}>
          <h2>MSA address:</h2>
          <p>Ziya Bunyadov ave., 2078 str., building 146D</p>
          <p>Baku, Azerbaijan</p>
        </div>
        <div className={classes.map}>
          <iframe
            title="MSA address"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3037.271621051587!2d49.887374!3d40.424984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDI1JzI5LjkiTiA0OcKwNTMnMTQuNiJF!5e0!3m2!1sen!2saz!4v1729500408553!5m2!1sen!2saz"
            loading="lazy"
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
}
